var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShuffle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_683_3312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8297 4.21484L18.3742 6.75929L15.8297 9.30373",
    stroke: "#1E293B",
    strokeWidth: 1.6963,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8297 17.7852L18.3742 15.2407L15.8297 12.6963",
    stroke: "#1E293B",
    strokeWidth: 1.6963,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10742 6.75928H5.65187C6.77658 6.75928 7.85523 7.20607 8.65052 8.00136C9.44582 8.79665 9.89261 9.8753 9.89261 11C9.89261 12.1247 10.3394 13.2034 11.1347 13.9987C11.93 14.794 13.0086 15.2408 14.1333 15.2408H18.3741",
    stroke: "#1E293B",
    strokeWidth: 1.6963,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19631 14.3935C7.46261 14.9446 6.5695 15.242 5.65187 15.2408H3.10742M18.3741 6.75928H14.1333C13.2163 6.75781 12.3238 7.05493 11.5906 7.60573L18.3741 6.75928Z",
    stroke: "#1E293B",
    strokeWidth: 1.6963,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_683_3312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.3556,
    height: 20.3556,
    fill: "white",
    transform: "translate(0.562988 0.822266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShuffle);
export default __webpack_public_path__ + "static/media/ic_shuffle.15372ef2840cdb84f6d9226ee4016c6b.svg";
export { ForwardRef as ReactComponent };